import { render, staticRenderFns } from "./AssignmentTableItemLog.vue?vue&type=template&id=6de2e183&scoped=true&"
import script from "./AssignmentTableItemLog.vue?vue&type=script&lang=js&"
export * from "./AssignmentTableItemLog.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentTableItemLog.vue?vue&type=style&index=0&id=6de2e183&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de2e183",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})
